import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '../core/core.module';
import { BtxSharedModule } from '../shared/btx-shared.module';
import { AdminPortalComponent } from './admin-portal.component';

@NgModule({
  declarations: [AdminPortalComponent],
  imports: [
    BtxSharedModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
  ],
  exports: [AdminPortalComponent],
})
export class AdminPortalModule {}
